import { Button, Form } from "react-bootstrap";
import SideModal from "../UI/SideModal/SideModal";
import { useEffect, useState } from "react";
import { AdminService } from "../../services/admin.service";
import toast from "react-hot-toast";

interface IAddCategoryModal {
    show: any
    handleClose: any,
    categoryData: any
}

export default function EditCategoryModal(props: IAddCategoryModal) {

    const [data, setData] = useState<any>()

    console.log(data)

    const editExamCategory = async () => {
        const payload = {
            name: data?.name,
            allowed: data?.allowed
        }
        await AdminService.editExamCategory(data._id, payload).then((res) => {
            if (res.status === 200) {
                props.handleClose()
            }
        }).catch((err) => {
            toast.error(err.response.data)
        })
    }

    useEffect(() => {
        setData(props.categoryData)
    }, [props.show])

    return (
        <>
            <SideModal
                show={props.show}
                handleClose={props.handleClose}
                title="Edit Exam Category"
                body={
                    <>
                        <Form.Group className="mb-3">
                            <Form.Label className="ds-label">Name</Form.Label>
                            <Form.Control defaultValue={data?.name} onChange={(e: any) => setData({ ...data, name: e.target.value })} />
                        </Form.Group>
                        <div className="ds-field-row">
                            <div>
                                <span className="ds-label" style={{ marginBottom: 0 }}>Allowed</span>
                                <span className="ds-help-text">Enable this exam category</span>
                            </div>
                            <Form.Switch checked={data?.allowed} onChange={(e: any) => setData({ ...data, allowed: e.target.checked })} />
                        </div>
                    </>
                }
                footer={
                    <div className="ds-drawer-actions">
                        <button className="ds-btn ds-btn-secondary" onClick={props.handleClose}>
                            Cancel
                        </button>
                        <button className="ds-btn ds-btn-primary" onClick={editExamCategory}>
                            Save
                        </button>
                    </div>
                }
            />
        </>
    )
}